import axios, { AxiosResponse } from 'axios'
import { ApiConfigType } from "./api-config"

import *as antd from "antd";

export const createHttp = (config: ApiConfigType) => {
    const http = axios.create({
        baseURL: config.url,
        validateStatus: status => status === 200,
        // withCredentials: true, // 默认的
        timeout: 60 * 1000 * 10,
    })


    http.interceptors.request.use(config => {
        const token = localStorage.getItem('jwt_token');
        const language = localStorage.getItem('jwt_language') 
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token ?? ''}`;
        config.headers['Accept-Language'] = language ?? 'zh-HK'

        return config;
    })


    http.interceptors.response.use(response => {
        console.log(`${response?.config?.method}====>${response?.config?.url}`, JSON.parse(JSON.stringify(response)))
        return response
    }, async (error) => {

        const response: AxiosResponse<any> = error?.response || {}
        console.error(`${response?.config?.method}====>${response?.config?.url}`, response)
        if (response.status !== 401) {

            antd.message.error(response.data.message)
        }


        throw error

    })
    return http
}



